import { getStoreBusinessDate } from "../../../../../../utilities/storeTime";

// Default dates for reports built from actuals. They anchor on the store's
// business date (its timezone, and a business day that may run past
// midnight), not the browser's calendar date, so "yesterday" is always a
// finished business day for that store.

function businessDateFor(storeNames, storeId) {
  const store = (storeNames || []).find((s) => s.id === storeId);
  if (store?.timezone) {
    const [y, m, d] = getStoreBusinessDate(store.timezone, store.start_qhnum)
      .split("-")
      .map(Number);
    return new Date(y, m - 1, d);
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}

// The store's most recent completed business day, as a local-midnight Date.
export function lastCompletedBusinessDay(storeNames, storeId) {
  const d = businessDateFor(storeNames, storeId);
  d.setDate(d.getDate() - 1);
  return d;
}

// Start of the store's last full business week (JS weekday index, Sunday=0).
export function lastCompletedBusinessWeekStart(storeNames, storeId, weekStartDayIndex) {
  const d = businessDateFor(storeNames, storeId);
  d.setDate(d.getDate() - ((d.getDay() - weekStartDayIndex + 7) % 7) - 7);
  return d;
}
